// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2diMF","largestCol":"styles_largestCol__1h6bw","smallestCol":"styles_smallestCol__TKTch"};